import { useEffect, useState } from "react";
import client, { LOGO_BANDEROLLE, LOGO_MARK, trackHit } from "../lib/api";
import { toast } from "sonner";
import { PromoStrip, LiveFallback } from "../components/Promo";
import InstallAppButton from "../components/InstallAppButton";

const GALLERY = [
  "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=1200&auto=format&fit=crop&q=70",
  "https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?w=1200&auto=format&fit=crop&q=70",
  "https://images.unsplash.com/photo-1459749411175-04bf5292ceea?w=1200&auto=format&fit=crop&q=70",
  "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=1200&auto=format&fit=crop&q=70",
  "https://images.unsplash.com/photo-1501386761578-eac5c94b800a?w=1200&auto=format&fit=crop&q=70",
  "https://images.unsplash.com/photo-1524368535928-5b5e00ddc76b?w=1200&auto=format&fit=crop&q=70",
  "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=1200&auto=format&fit=crop&q=70",
  "https://images.unsplash.com/photo-1506157786151-b8491531f063?w=1200&auto=format&fit=crop&q=70",
];

const UK_MAGAZINES = [
  { title: "UK Mag Vol-2", cover: "https://unitedkreol.com/wp-content/uploads/2021/04/IMAGE-2021-04-13-000236.jpg", url: "https://unitedkreol.com/produit/magazine-vol-2/", price: "€1.99" },
  { title: "UK Mag Vol-5", cover: "https://unitedkreol.com/wp-content/uploads/2022/02/IMAGE-2022-02-09-204726-300x424.jpg", url: "https://unitedkreol.com/produit/uk-mag-vol-5/", price: "€3.99" },
  { title: "UK Mag Vol-6", cover: "https://unitedkreol.com/wp-content/uploads/2022/04/Capture-decran-2022-04-10-a-18.58.23-300x434.png", url: "https://unitedkreol.com/produit/uk-mag-vol-6/", price: "€3.99" },
  { title: "UK Mag My Lux Vol-1", cover: "https://unitedkreol.com/wp-content/uploads/2022/08/Capture-de%CC%81cran-2022-08-25-a%CC%80-20.40.09-300x437.png", url: "https://unitedkreol.com/produit/uk-mag-my-lux-vol-1/", price: "€1.99" },
  { title: "UK Mag Vol-9 USA", cover: "https://unitedkreol.com/wp-content/uploads/2022/12/Capture-decran-2022-12-26-a-12.33.55-300x441.png", url: "https://unitedkreol.com/produit/uk-mag-vol-9-usa/", price: "€3.99" },
];

const WEATHER_ICON = (code) => {
  if (code === undefined || code === null) return "fa-cloud-question";
  if (code === 0) return "fa-sun";
  if (code <= 3) return "fa-cloud-sun";
  if (code <= 48) return "fa-smog";
  if (code <= 67) return "fa-cloud-rain";
  if (code <= 77) return "fa-snowflake";
  if (code <= 82) return "fa-cloud-showers-heavy";
  return "fa-cloud-bolt";
};

const Divider = () => (
  <div className="ornament-divider">
    <span className="line" />
    <i className="fa-solid fa-crown" style={{ color: "var(--amatour-gold)", fontSize: 12 }} />
    <span className="diamond" />
    <i className="fa-solid fa-crown" style={{ color: "var(--amatour-gold)", fontSize: 12 }} />
    <span className="line" />
  </div>
);

export default function PublicHome({ t, lang, setLang, onLogin, content }) {
  const [events, setEvents] = useState([]);
  const [music, setMusic] = useState([]);
  const [weather, setWeather] = useState([]);
  const [promosEvents, setPromosEvents] = useState([]);
  const [liveFallbacks, setLiveFallbacks] = useState([]);
  const [section, setSection] = useState("home");
  const [donation, setDonation] = useState({ company_name: "", contact_name: "", email: "", phone: "", amount: "", message: "" });
  const [contact, setContact] = useState({ name: "", email: "", subject: "", message: "" });
  const [sending, setSending] = useState(false);

  useEffect(() => { trackHit("/"); }, []);
  useEffect(() => {
    client.get("/events").then((r) => setEvents(r.data)).catch(() => {});
    client.get("/music").then((r) => setMusic(r.data)).catch(() => {});
    client.get("/weather").then((r) => setWeather(r.data)).catch(() => {});
    client.get("/promos?position=events").then((r) => setPromosEvents(r.data)).catch(() => {});
    client.get("/promos?position=live_fallback").then((r) => setLiveFallbacks(r.data)).catch(() => {});
  }, []);

  const scrollTo = (id) => {
    setSection(id);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const submitDonation = async (e) => {
    e.preventDefault();
    if (!donation.company_name || !donation.amount) { toast.error("Nom d'entreprise et montant requis"); return; }
    setSending(true);
    try {
      await client.post("/donations", { ...donation, amount: parseFloat(donation.amount) });
      toast.success(t.donate.thanks);
      setDonation({ company_name: "", contact_name: "", email: "", phone: "", amount: "", message: "" });
    } catch { toast.error("Erreur envoi"); }
    finally { setSending(false); }
  };
  const submitContact = async (e) => {
    e.preventDefault();
    if (!contact.name || !contact.email || !contact.message) { toast.error("Champs obligatoires"); return; }
    setSending(true);
    try {
      await client.post("/contact", contact);
      toast.success("Message envoyé");
      setContact({ name: "", email: "", subject: "", message: "" });
    } catch { toast.error("Erreur envoi"); }
    finally { setSending(false); }
  };

  const now = new Date();
  const upcoming = events.filter((e) => !e.date || new Date(e.date) >= now);
  const c = content || {};

  return (
    <div className="amatour-shell grain">
      {/* BANDEAU MÉTÉO — tout en haut, avant tribe-flag/ribbon/nav */}
      <section className="py-4" style={{ background: "linear-gradient(90deg, #b45309 0%, #f59e0b 18%, #22c55e 38%, #06b6d4 58%, #a855f7 78%, #ec4899 100%)", boxShadow: "0 4px 20px rgba(0,0,0,0.18)" }} data-testid="weather-banner">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-3">
            <div style={{ fontFamily: "'Cinzel', serif", fontSize: 11, fontWeight: 800, letterSpacing: "0.28em", color: "#ffffff", textTransform: "uppercase", textShadow: "0 2px 8px rgba(0,0,0,0.4)" }}>
              <i className="fa-solid fa-globe" /> &nbsp;Météo tournée &mdash; France · Afrique · DOM-TOM
            </div>
          </div>
          <div className="marquee" style={{ background: "linear-gradient(135deg, rgba(255,255,255,0.95), rgba(255,248,220,0.95))", padding: "14px 20px", borderRadius: "4px", boxShadow: "inset 0 0 24px rgba(180,83,9,0.14), 0 4px 14px rgba(0,0,0,0.18)", border: "2px solid rgba(255,255,255,0.9)" }}>
            <div className="track">
              {[...weather, ...weather].map((w, i) => (
                <div key={`${w.name}-${i}`} className="flex items-center gap-3 whitespace-nowrap" data-testid={`weather-${w.name}`}>
                  <i className={`fa-solid ${WEATHER_ICON(w.code)}`} style={{ color: "#b45309", fontSize: 24 }} />
                  <div>
                    <div style={{ fontFamily: "'Cinzel', serif", fontSize: 12, fontWeight: 700, letterSpacing: "0.14em", color: "#1a1a1f", textTransform: "uppercase" }}>{w.name}<span style={{ color: "#7f1220", marginLeft: 6, fontFamily: "'Cormorant Garamond', serif", fontStyle: "italic", fontWeight: 500, textTransform: "none", letterSpacing: 0 }}>· {w.country}</span></div>
                    <div style={{ color: "#2c2c34", fontFamily: "'Cormorant Garamond', serif", fontSize: 14, fontWeight: 600 }}>{w.temp != null ? `${Math.round(w.temp)}°C · ${t.weather.wind} ${Math.round(w.wind || 0)} km/h` : "—"}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <div className="tribe-flag" />

      {/* ADMIN ACCESS RIBBON */}
      <div style={{ background: "linear-gradient(90deg, rgba(212,175,55,0.14), rgba(212,175,55,0.05), rgba(212,175,55,0.14))", borderBottom: "1px solid var(--amatour-line)" }}>
        <div className="max-w-7xl mx-auto px-8 py-2.5 flex items-center justify-between gap-4 flex-wrap text-xs">
          <div className="italic-accent"><i className="fa-solid fa-envelope mr-2" style={{ color: "var(--amatour-warm-deep)" }} />staff@amatour-festival.com</div>
          <div className="flex items-center gap-4 flex-wrap">
            <InstallAppButton />
            <button onClick={onLogin} className="flex items-center gap-2 transition hover:opacity-70" data-testid="btn-login-ribbon" style={{ color: "var(--amatour-gold-deep)", fontFamily: "Cinzel, serif", letterSpacing: "0.2em", textTransform: "uppercase", fontSize: 10, fontWeight: 700 }}>
              <i className="fa-solid fa-crown" /> Espace fondateurs &amp; admin <i className="fa-solid fa-arrow-right" />
            </button>
          </div>
        </div>
      </div>

      {/* NAV */}
      <nav className="sticky top-0 z-30 backdrop-blur-xl" style={{ background: "rgba(253,250,241,0.92)", borderBottom: "1px solid var(--amatour-line)" }} data-testid="public-nav">
        <div className="max-w-7xl mx-auto px-8 py-4 flex items-center justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-4 cursor-pointer" onClick={() => scrollTo("home")}>
            <img src={LOGO_MARK} alt="Amatour" style={{ height: 52, width: 52, objectFit: "contain" }} />
            <div className="border-l pl-4" style={{ borderColor: "var(--amatour-line-strong)" }}>
              <div className="font-editorial text-base leading-tight" style={{ color: "var(--amatour-ink)", letterSpacing: "0.28em", fontWeight: 700 }}>AMATOUR</div>
              <div className="font-serif-italic text-xs mt-0.5" style={{ color: "var(--amatour-gold-deep)", letterSpacing: "0.12em" }}>Festival International</div>
            </div>
          </div>
          <div className="flex items-center gap-1 flex-wrap">
            {["home", "events", "music", "magazines", "live", "donate", "contact"].map((k) => (
              <div key={k} className={`navlink ${section === k ? "active" : ""}`} onClick={() => scrollTo(k)} data-testid={`nav-${k}`}>{t.nav[k] || (k === "magazines" ? "Magazines" : k)}</div>
            ))}
            <select value={lang} onChange={(e) => setLang(e.target.value)} className="input-amatour ml-3" style={{ padding: "8px 12px", width: "auto", fontSize: 11, letterSpacing: "0.15em", fontFamily: "Cinzel, serif" }} data-testid="lang-select">
              <option value="fr">FR</option><option value="en">EN</option><option value="es">ES</option>
            </select>
            <button className="btn-gold ml-3" onClick={onLogin} data-testid="btn-login-header" style={{ padding: "10px 22px", fontSize: 11 }}><i className="fa-solid fa-lock" /> &nbsp;{t.nav.login}</button>
          </div>
        </div>
      </nav>

      {/* HERO — layout deux colonnes propre */}
      <section id="home" className="relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-8 pt-20 pb-24 grid md:grid-cols-2 gap-14 items-center relative z-10">
          <div className="fade-in">
            <div className="ribbon-gold mb-8 fade-in fade-in-delay-1"><i className="fa-solid fa-crown" />&nbsp;{c.next_festival || "1er Festival Amatour · 2027"}</div>
            <h1 className="hero-title mb-6 fade-in fade-in-delay-2">
              <span className="gold-accent">AMATOUR</span>
            </h1>
            <div className="italic-accent mb-8 fade-in fade-in-delay-2" style={{ fontSize: "28px", lineHeight: 1.2 }}>festival international</div>
            <p className="mb-10 max-w-xl fade-in fade-in-delay-3" style={{ color: "var(--amatour-ink-2)", fontFamily: "'Cormorant Garamond', serif", fontSize: "22px", fontWeight: 500, lineHeight: 1.5 }}>
              {c.hero_subtitle || "La scène internationale qui réunit la France et l'Afrique."}
            </p>
            <div className="flex gap-4 flex-wrap fade-in fade-in-delay-3">
              <button className="btn-gold" onClick={() => scrollTo("events")} data-testid="hero-cta-events"><i className="fa-solid fa-ticket" /> &nbsp;{t.hero.tickets}</button>
              <button className="btn-outline" onClick={() => scrollTo("donate")} data-testid="hero-cta-donate"><i className="fa-solid fa-hand-holding-heart" /> &nbsp;{t.hero.donate}</button>
            </div>
          </div>
          <div className="fade-in fade-in-delay-2 relative">
            <div className="absolute -inset-4 rounded-lg" style={{ background: "linear-gradient(135deg, rgba(212,175,55,0.25), rgba(185,30,44,0.15))", filter: "blur(30px)", zIndex: 0 }} />
            <img src={LOGO_BANDEROLLE} alt="Amatour Festival 2027" className="w-full rounded-lg relative z-10" style={{ boxShadow: "0 30px 80px -20px rgba(26,26,31,0.35)" }} />
          </div>
        </div>
      </section>

      <Divider />

      {/* EVENTS */}
      <section id="events" className="max-w-7xl mx-auto px-8 py-24">
        <div className="text-center mb-16">
          <div className="section-eyebrow"><i className="fa-solid fa-calendar-star" /> {t.nav.events}</div>
          <h2 className="section-title mt-2">{t.events.title}</h2>
          <p className="italic-accent mt-4 text-lg max-w-xl mx-auto" style={{ color: "var(--amatour-ink-2)" }}>Vivez l'émotion des grands rendez-vous musicaux entre deux continents.</p>
        </div>
        {upcoming.length === 0 && (
          <div className="card-amatour card-corners p-16 text-center italic-accent text-lg">{t.events.none}</div>
        )}

        {promosEvents.length > 0 && (
          <div className="mb-12"><PromoStrip promos={promosEvents} /></div>
        )}

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {upcoming.map((ev) => (
            <div key={ev.id} className="card-warm card-hover-lift fade-in overflow-hidden" data-testid={`event-${ev.id}`}>
              {ev.poster_url && (
                <div className="event-poster">
                  <img src={ev.poster_url} alt={ev.title} className="w-full h-52 object-cover" />
                </div>
              )}
              <div className="p-7">
                <div className="font-editorial text-[10px] mb-3" style={{ color: "var(--amatour-gold)", letterSpacing: "0.22em" }}>{ev.date && new Date(ev.date).toLocaleDateString(lang === "en" ? "en-GB" : "fr-FR", { day: "2-digit", month: "long", year: "numeric" })}</div>
                <h3 className="font-display text-2xl mb-2 leading-tight">{ev.title}</h3>
                <div className="italic-accent text-sm mb-4" style={{ color: "var(--amatour-ink-2)" }}><i className="fa-solid fa-location-dot mr-1" style={{ color: "var(--amatour-warm-deep)" }} />{ev.location}{ev.country && `, ${ev.country}`}</div>
                <p className="text-sm mb-5 line-clamp-3" style={{ color: "var(--amatour-ink-2)" }}>{ev.description}</p>
                <div className="flex items-center justify-between pt-4 border-t" style={{ borderColor: "var(--amatour-line)" }}>
                  {ev.price_from > 0 ? <div className="font-editorial text-sm gold-accent">{t.events.from} {ev.price_from}€</div> : <div />}
                  <span className={`chip ${ev.status === "live" ? "chip-red" : ev.status === "past" ? "" : "chip-green"}`}>{ev.status}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <Divider />

      {/* GALERIE — ambiance festival (AVANT musique) */}
      <section className="warm-band py-24">
        <div className="max-w-7xl mx-auto px-8">
          <div className="text-center mb-12">
            <div className="section-eyebrow"><i className="fa-solid fa-camera-retro" /> Ambiance festival</div>
            <h2 className="section-title mt-2">L'émotion en images</h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {GALLERY.map((src, i) => (
              <div key={i} className="card-amatour overflow-hidden fade-in aspect-square" style={{ animationDelay: `${i * 0.06}s` }}>
                <img src={src} alt="" loading="lazy" className="w-full h-full object-cover transition-transform duration-700 hover:scale-110" />
              </div>
            ))}
          </div>
        </div>
      </section>

      <Divider />

      {/* MUSIC */}
      <section id="music" className="max-w-7xl mx-auto px-8 py-24">
        <div className="text-center mb-16">
          <div className="section-eyebrow"><i className="fa-solid fa-music" /> {t.music.ai}</div>
          <h2 className="section-title mt-2">{t.music.title}</h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {music.map((m) => (
            <div key={m.id} className="card-warm card-corners card-hover-lift p-7 fade-in" data-testid={`music-${m.id}`}>
              <div className="flex flex-wrap items-center gap-2 mb-4">
                <span className={`chip ${m.region === "France" ? "chip-red" : "chip-green"}`}>{m.region}</span>
                {m.country && <span className="tag">{m.country}</span>}
                {m.genre && <span className="tag">{m.genre}</span>}
              </div>
              <h4 className="font-display text-xl mb-1 leading-tight">{m.title}</h4>
              {m.artist && <div className="italic-accent mb-3" style={{ color: "var(--amatour-warm-deep)", fontWeight: 600 }}>{m.artist}</div>}
              <p className="text-sm" style={{ color: "var(--amatour-ink-2)", lineHeight: 1.6 }}>{m.summary}</p>
            </div>
          ))}
          {music.length === 0 && <div className="col-span-full card-amatour p-12 text-center italic-accent"><i className="fa-solid fa-spinner spin mr-2" /> Chargement…</div>}
        </div>
      </section>

      <Divider />

      {/* MAGAZINES UK MAG */}
      <section className="max-w-7xl mx-auto px-8 py-24" id="magazines">
        <div className="text-center mb-14">
          <div className="section-eyebrow"><i className="fa-solid fa-book-open" /> La collection UK Mag</div>
          <h2 className="section-title mt-2">Les artistes du monde</h2>
          <p className="italic-accent mt-4 text-lg max-w-2xl mx-auto" style={{ fontSize: "20px" }}>
            Musique, art, mode et people — disponibles en version numérique sur <strong style={{ color: "var(--amatour-warm-deep)" }}>United Kreol</strong>
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {UK_MAGAZINES.map((m) => (
            <a key={m.url} href={m.url} target="_blank" rel="noreferrer" className="card-amatour card-hover-lift overflow-hidden group fade-in" data-testid={`mag-${m.title.replace(/\s+/g, "-")}`}>
              <div className="aspect-[3/4] overflow-hidden bg-gray-100">
                <img src={m.cover} alt={m.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
              </div>
              <div className="p-4 text-center">
                <div className="font-display text-base leading-tight" style={{ color: "var(--amatour-ink)" }}>{m.title}</div>
                <div className="mt-2 flex items-center justify-center gap-3">
                  <span className="chip">{m.price}</span>
                  <span className="italic-accent text-xs" style={{ color: "var(--amatour-warm-deep)" }}><i className="fa-solid fa-arrow-up-right-from-square" /></span>
                </div>
              </div>
            </a>
          ))}
        </div>
        <div className="text-center mt-10">
          <a href="https://unitedkreol.com/categorie-produit/magazine/" target="_blank" rel="noreferrer" className="btn-outline">
            <i className="fa-solid fa-globe" /> &nbsp;Voir toute la collection UK Mag
          </a>
        </div>
      </section>

      <Divider />

      {/* LIVE */}
      <section id="live" className="max-w-7xl mx-auto px-8 py-24">
        <div className="text-center mb-12">
          <div className="section-eyebrow"><i className="fa-solid fa-signal-stream" /> {t.live.title}</div>
          <h2 className="section-title mt-2">{c.live_title || t.live.title}</h2>
        </div>
        <div className="card-amatour card-corners p-2 aspect-video overflow-hidden">
          {c.live_url ? (
            <iframe src={c.live_url} title="Live" className="w-full h-full" allow="autoplay; encrypted-media; picture-in-picture" allowFullScreen />
          ) : liveFallbacks.length > 0 ? (
            <LiveFallback videos={liveFallbacks} poster={LOGO_BANDEROLLE} />
          ) : (
            <div className="w-full h-full flex flex-col items-center justify-center text-center p-12" style={{ background: "radial-gradient(ellipse at center, rgba(212,175,55,0.10), rgba(253,250,241,0.6))" }}>
              <i className="fa-solid fa-satellite-dish text-7xl mb-6" style={{ color: "var(--amatour-gold)" }} />
              <p className="italic-accent text-xl max-w-md leading-relaxed" style={{ color: "var(--amatour-ink)" }}>{t.live.offline}</p>
              <div className="flex gap-3 mt-8">
                {["instagram", "facebook", "youtube", "tiktok"].map((n) => c.socials?.[n] && (
                  <a key={n} href={c.socials[n]} target="_blank" rel="noreferrer" className="btn-ghost"><i className={`fa-brands fa-${n}`} /></a>
                ))}
              </div>
            </div>
          )}
        </div>
      </section>

      <Divider />

      {/* DONATIONS */}
      <section id="donate" className="max-w-4xl mx-auto px-8 py-24">
        <div className="text-center mb-12">
          <div className="section-eyebrow"><i className="fa-solid fa-hand-holding-heart" /> {t.nav.donate}</div>
          <h2 className="section-title mt-2">{t.donate.title}</h2>
          <p className="italic-accent mt-4 text-lg" style={{ color: "var(--amatour-ink-2)" }}>{t.donate.subtitle}</p>
        </div>
        <form className="card-amatour card-corners p-10 grid md:grid-cols-2 gap-5" onSubmit={submitDonation} data-testid="donation-form">
          <div><label className="label-amatour">{t.donate.company} *</label><input className="input-amatour" value={donation.company_name} onChange={(e) => setDonation({ ...donation, company_name: e.target.value })} required data-testid="donation-company" /></div>
          <div><label className="label-amatour">{t.donate.contact}</label><input className="input-amatour" value={donation.contact_name} onChange={(e) => setDonation({ ...donation, contact_name: e.target.value })} /></div>
          <div><label className="label-amatour">{t.donate.email}</label><input type="email" className="input-amatour" value={donation.email} onChange={(e) => setDonation({ ...donation, email: e.target.value })} /></div>
          <div><label className="label-amatour">{t.donate.phone}</label><input className="input-amatour" value={donation.phone} onChange={(e) => setDonation({ ...donation, phone: e.target.value })} /></div>
          <div><label className="label-amatour">{t.donate.amount} *</label><input type="number" step="1" className="input-amatour" value={donation.amount} onChange={(e) => setDonation({ ...donation, amount: e.target.value })} required data-testid="donation-amount" /></div>
          <div className="md:col-span-2"><label className="label-amatour">{t.donate.message}</label><textarea rows={4} className="input-amatour" value={donation.message} onChange={(e) => setDonation({ ...donation, message: e.target.value })} /></div>
          <div className="md:col-span-2 flex justify-center pt-4"><button type="submit" className="btn-gold" disabled={sending} data-testid="donation-submit">{sending ? <><i className="fa-solid fa-spinner spin" /> Envoi…</> : <><i className="fa-solid fa-paper-plane" /> &nbsp;{t.donate.submit}</>}</button></div>
        </form>
      </section>

      <Divider />

      {/* CONTACT */}
      <section id="contact" className="max-w-7xl mx-auto px-8 py-24">
        <div className="grid md:grid-cols-2 gap-16 items-start">
          <div>
            <div className="section-eyebrow left-only"><i className="fa-solid fa-envelope" /> {t.nav.contact}</div>
            <h2 className="section-title mt-2 mb-6">{t.contact.title}</h2>
            <p className="italic-accent text-lg mb-10" style={{ color: "var(--amatour-ink-2)" }}>{t.contact.subtitle}</p>
            <div className="card-amatour card-corners p-8 space-y-5">
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ background: "rgba(212,175,55,0.1)", border: "1px solid var(--amatour-line-strong)" }}>
                  <i className="fa-solid fa-envelope" style={{ color: "var(--amatour-gold)" }} />
                </div>
                <a href={`mailto:${t.contact.email}`} className="hover:text-amber-300 transition">{t.contact.email}</a>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ background: "rgba(212,175,55,0.1)", border: "1px solid var(--amatour-line-strong)" }}>
                  <i className="fa-solid fa-globe" style={{ color: "var(--amatour-gold)" }} />
                </div>
                <span>amatour-festival.com</span>
              </div>
              <div className="italic-accent text-sm pt-4 border-t" style={{ borderColor: "var(--amatour-line)", color: "var(--amatour-ink-3)" }}>© {new Date().getFullYear()} Amatour Festival International — All rights reserved.</div>
              <button onClick={onLogin} className="btn-outline w-full mt-3" data-testid="btn-login-footer">
                <i className="fa-solid fa-crown" /> &nbsp;Espace Fondateurs &amp; Administration
              </button>
            </div>
          </div>
          <form className="card-amatour card-corners p-10 space-y-5" onSubmit={submitContact} data-testid="contact-form">
            <div><label className="label-amatour">{t.contact.name} *</label><input className="input-amatour" value={contact.name} onChange={(e) => setContact({ ...contact, name: e.target.value })} required data-testid="contact-name" /></div>
            <div><label className="label-amatour">Email *</label><input type="email" className="input-amatour" value={contact.email} onChange={(e) => setContact({ ...contact, email: e.target.value })} required data-testid="contact-email" /></div>
            <div><label className="label-amatour">{t.contact.subject}</label><input className="input-amatour" value={contact.subject} onChange={(e) => setContact({ ...contact, subject: e.target.value })} /></div>
            <div><label className="label-amatour">{t.contact.message} *</label><textarea rows={5} className="input-amatour" value={contact.message} onChange={(e) => setContact({ ...contact, message: e.target.value })} required data-testid="contact-message" /></div>
            <div className="flex justify-center pt-2"><button type="submit" className="btn-gold" disabled={sending} data-testid="contact-submit">{sending ? "…" : <><i className="fa-solid fa-paper-plane" /> &nbsp;{t.contact.submit}</>}</button></div>
          </form>
        </div>
      </section>

      <div className="tribe-flag" />
    </div>
  );
}
